import axios from 'axios'
import Result from '../../utils/serviceResultPattern'

export default {
    createPayIn(payload) {
        return axios
            .post('/api/payments/pay-in', payload)
            .then((res) => {
                if (res.status < 200 || res.status >= 300) {
                    return Result.error("We couldn't save the payment at this time. Please try again or contact support if the issue persists.")
                }
                return Result.ok(res.data)
            })
            .catch((error) => {
                return Result.error(error)
            })
    },

    editPayIn(payload) {
        return axios
            .post('/api/payments/pay-in/edit', payload)
            .then((res) => {
                if (res.status < 200 || res.status >= 300) {
                    return Result.error("We couldn't update the payment at this time. Please try again or contact support if the issue persists.")
                }
                return Result.ok(res.data)
            })
            .catch((error) => {
                return Result.error(error)
            })
    },

    deletePayIn(paymentId) {
        return axios
            .delete(`/api/payments/pay-in/${paymentId}/delete`)
            .then((res) => {
                return Result.ok(res.data);
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.error) {
                    return Result.error(error.response.data.error);
                }

                return Result.error(
                    "We couldn't delete the payment at this time. Please try again or contact support if the issue persists."
                );
            })
    },
}



// WEBPACK FOOTER //
// ./src/api/reservation/payInService.js